export default __webpack_public_path__ + "media/images/features/ambassador/profiles/berina_san-4f3a33e1e59133219d6b9021f35d547a.jpg";